<div id="mainBase">
    <app-header></app-header>

    <div class="homeSlide baseContainer">
        <ngx-slick-carousel *ngIf="Slides" class="homeCarousel" #slickModal="slick-carousel" [config]="homeSlideConfig" (beforeChange)="sliding = true" (afterChange)="sliding = false">
            <div ngxSlickItem class="slideItem" *ngFor="let slide of Slides" (click)="!sliding && navigate(slide, true)">
                <img [src]="slide.slider_image_url" [alt]="slide.name">
                <div class="slideInfo">
                    <h6>{{ slide.name }}</h6>
                </div>
            </div>
        </ngx-slick-carousel>

        <div *ngIf="!Slides" class="contentLoader my-5 pt-5 pb-4"><span></span></div>
    </div>

    <div class="baseContainer">
        <!-- <div class="search">
            <input #search type="text" [placeholder]="'home.searchVoucher' | translate" (keyup.enter)="gotoSearch(search.value)"><span (click)="gotoSearch(search.value)"><i class="fas fa-search"></i></span>
        </div> -->
        <h1 class="mt-5 mb-3">{{ (categoryTitle || 'home.popularTitles') | translate }}</h1>
        
        <main class="voucherBox">
            <a *ngFor="let voucher of uparInfoCms.popVouchers" (click)="!sliding && navigate(voucher)" [hidden]="voucher.type != 'VOUCHER'" class="voucher">
                <img [src]="voucher.image_url" [alt]="voucher.name">
                <span [class.hided]="!voucher.discountLabel" [innerHTML]="voucher.discountLabel || '<b>-</b>'"></span>
                <b>{{ voucher.name }}</b>
                <p [innerHTML]="voucher.priceLabel"></p>
            </a>
                
            <h5 *ngIf="!!uparInfoCms.popVouchers && !uparInfoCms.popVouchers.length" class="text-center py-5 my-5">{{ 'home.noVoucherFound' | translate }}</h5>        
            <div *ngIf="!uparInfoCms.popVouchers" class="contentLoader my-5 py-5"><span></span></div>
        </main>
    </div>
    
    <!-- <app-vouchers [showHeader]="false"></app-vouchers> -->

    <div class="baseContainer pb-3">
        <a routerLink="/vouchers" (click)="event.eventStart({ eventType: 'CONTENT_LIST_CLICK', eventCategory: 'CLICK' })" class="btn px-3">{{ 'home.fullCatalogue' | translate }}</a>
    </div>

    <div *ngIf="!!uparInfoCms.uparAdvantages?.length" class="benefits">
        <div class="baseContainer">
            <h5>{{ 'home.whatIsUpar' | translate }}</h5>

            <div *ngFor="let tip of uparInfoCms.uparAdvantages" class="benefit">
                <img [src]="tip.image_url" [alt]="tip.name" class="icon">
                <h6>{{ tip.subtitle }}</h6>
                <p>{{ tip.description }}</p>
            </div>

        </div>
    </div>

    <div *ngIf="!!uparInfoCms.paymentMethods?.length" class="payments">
        <div class="baseContainer">
            <h5>{{ 'home.paymentMethods' | translate }}</h5>
            <img height="20px" *ngFor="let pm of uparInfoCms.paymentMethods" [src]="pm.payment_method_image" [alt]="pm.name">
        </div>
    </div>

    <div *ngIf="!!uparInfoCms.socialMediaList?.length" class="followUs">
        <div class="baseContainer">
            <h6>{{ 'home.followUs' | translate }}</h6>
            <div class="socials">
                <a *ngFor="let sm of uparInfoCms.socialMediaList" [href]="sm.social_media_url" target="_blank" [title]="sm.name"><i [class]="socialNetwork[sm.social_media_type?.toLowerCase()]"></i></a>
            </div>
        </div>
    </div>

    <!-- <div class="sep">
        <a routerLink="/about/faq" class="baseContainer">
            <img src="https://webportals.cachefly.net/global/upar/assets/images/icons/ic_help.svg" alt="Help Icon" class="icon">
            <h6>{{ 'global.portal-help' | translate }}</h6>
            <span class="arrowRight"><i class="fas fa-chevron-right"></i></span>
        </a>
    </div> -->

    <div class="infoCTA">
        <div class="baseContainer">
            <a routerLink="/about/terms" (click)="event.eventStart({ eventType: 'TC_CLICK', eventCategory: 'CLICK' })">{{ 'global.portal-terms' | translate }}</a>
            <a routerLink="/about/policies" (click)="event.eventStart({ eventType: 'PRIVACY_POLICY_CLICK', eventCategory: 'CLICK' })">{{ 'global.portal-policies' | translate }}</a>
        </div>
    </div>

    <div class="bottom">
        <div class="baseContainer">
            <img src="https://webportals.cachefly.net/global/upar/assets/images/icons/ic_mini_logo{{ LightTheme$ ? '' : '_dark' }}.svg" alt="Logo Upar">
            <p>{{ 'home.copyright' | translate }}</p>
            <!-- <a *ngIf="global.propConfs$?.emailSupport" (click)="supportPopUp(global.propConfs$.emailSupport)" class="suport" [innerHTML]="'home.needHelp' | translate"></a> -->
        </div>
    </div>
    
</div>